"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayedPreRollAdInfo = exports.InventoryRequestDebugFlags = exports.InventoryRequest = exports.PetraFeatureFlags = exports.FeatureFlags = exports.DiscoverChannelMetadata = exports.ResponseDataType = exports.ResponseDataType_Enum = void 0;
const long_1 = __importDefault(require("long"));
const engagement_1 = require("./engagement");
const dpa_ad_metadata_1 = require("../adindex/dpa/dpa_ad_metadata");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
var ResponseDataType_Enum;
(function (ResponseDataType_Enum) {
    ResponseDataType_Enum[ResponseDataType_Enum["JSON"] = 0] = "JSON";
    ResponseDataType_Enum[ResponseDataType_Enum["PROTO"] = 1] = "PROTO";
    ResponseDataType_Enum[ResponseDataType_Enum["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ResponseDataType_Enum = exports.ResponseDataType_Enum || (exports.ResponseDataType_Enum = {}));
function createBaseResponseDataType() {
    return {};
}
exports.ResponseDataType = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseResponseDataType();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseResponseDataType();
        return message;
    },
};
function createBaseDiscoverChannelMetadata() {
    return {
        inventoryFullyQualified: "",
        channel: "",
        channelId: "",
        productType: "",
        publisher: "",
        publisherId: "0",
        editionId: "0",
        posterId: "",
    };
}
exports.DiscoverChannelMetadata = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.inventoryFullyQualified !== "") {
            writer.uint32(10).string(message.inventoryFullyQualified);
        }
        if (message.channel !== "") {
            writer.uint32(18).string(message.channel);
        }
        if (message.channelId !== "") {
            writer.uint32(26).string(message.channelId);
        }
        if (message.productType !== "") {
            writer.uint32(34).string(message.productType);
        }
        if (message.publisher !== "") {
            writer.uint32(42).string(message.publisher);
        }
        if (message.publisherId !== "0") {
            writer.uint32(48).int64(message.publisherId);
        }
        if (message.editionId !== "0") {
            writer.uint32(56).int64(message.editionId);
        }
        if (message.posterId !== "") {
            writer.uint32(66).string(message.posterId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDiscoverChannelMetadata();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.inventoryFullyQualified = reader.string();
                    break;
                case 2:
                    message.channel = reader.string();
                    break;
                case 3:
                    message.channelId = reader.string();
                    break;
                case 4:
                    message.productType = reader.string();
                    break;
                case 5:
                    message.publisher = reader.string();
                    break;
                case 6:
                    message.publisherId = longToString(reader.int64());
                    break;
                case 7:
                    message.editionId = longToString(reader.int64());
                    break;
                case 8:
                    message.posterId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDiscoverChannelMetadata();
        message.inventoryFullyQualified = object.inventoryFullyQualified ?? "";
        message.channel = object.channel ?? "";
        message.channelId = object.channelId ?? "";
        message.productType = object.productType ?? "";
        message.publisher = object.publisher ?? "";
        message.publisherId = object.publisherId ?? "0";
        message.editionId = object.editionId ?? "0";
        message.posterId = object.posterId ?? "";
        return message;
    },
};
function createBaseFeatureFlags() {
    return {
        isPetraCapable: false,
        isDpaCapable: false,
        protoCapableAdTypes: [],
        canSupportCognacSkippableAds: false,
        canSupportExtendedPlayAds: false,
        dpaCapableAdTypes: [],
        storyAdsInUserStoriesEnabled: false,
        petraFeatureFlags: undefined,
        canSupportShowsSkippableAds: false,
        supportedAdTypes: [],
        additionalFormatType: 0,
        storyAdsInContentInterstitialEnabled: false,
        canSupportCollectionV2: false,
        maxSupportedSkAdNetworkVersion: "",
        canSupportCollectionAppInstall: false,
        topsnapProductsInShowcaseAttachment: false,
        canSupportCollectionShowcaseAttachment: false,
        canSupportLeadGenV15: false,
        maxSupportedSkAdNetworkViewThroughVersion: "",
        canSupportDpaStoryAds: false,
        supportedLeadGenVersion: undefined,
        canSupportDefaultBrowserDeeplinkFallback: false,
        composerSupportedItemTypes: [],
        supportedDpaComposerTemplateVersion: undefined,
        supportsOrganicStore: false,
        multiAdPodRequestEnabled: false,
        offerDisclaimerEnabled: false,
        canSupportMultiImageComposerTemplates: false,
        canSupportSkanAdsets: false,
        isSnapchatPlusAdFreeTier: false,
        supportedThirdPartyLoginSources: [],
        supportedInteractiveStickers: [],
        isBroccoliCarouselRequest: false,
        canSupportDpaCollectionAsSnapAd: false,
    };
}
exports.FeatureFlags = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.isPetraCapable === true) {
            writer.uint32(8).bool(message.isPetraCapable);
        }
        if (message.isDpaCapable === true) {
            writer.uint32(16).bool(message.isDpaCapable);
        }
        writer.uint32(26).fork();
        for (const v of message.protoCapableAdTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.canSupportCognacSkippableAds === true) {
            writer.uint32(32).bool(message.canSupportCognacSkippableAds);
        }
        if (message.canSupportExtendedPlayAds === true) {
            writer.uint32(40).bool(message.canSupportExtendedPlayAds);
        }
        writer.uint32(50).fork();
        for (const v of message.dpaCapableAdTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.storyAdsInUserStoriesEnabled === true) {
            writer.uint32(56).bool(message.storyAdsInUserStoriesEnabled);
        }
        if (message.petraFeatureFlags !== undefined) {
            exports.PetraFeatureFlags.encode(message.petraFeatureFlags, writer.uint32(66).fork()).ldelim();
        }
        if (message.canSupportShowsSkippableAds === true) {
            writer.uint32(72).bool(message.canSupportShowsSkippableAds);
        }
        writer.uint32(82).fork();
        for (const v of message.supportedAdTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.additionalFormatType !== 0) {
            writer.uint32(88).int32(message.additionalFormatType);
        }
        if (message.storyAdsInContentInterstitialEnabled === true) {
            writer.uint32(96).bool(message.storyAdsInContentInterstitialEnabled);
        }
        if (message.canSupportCollectionV2 === true) {
            writer.uint32(104).bool(message.canSupportCollectionV2);
        }
        if (message.maxSupportedSkAdNetworkVersion !== "") {
            writer.uint32(114).string(message.maxSupportedSkAdNetworkVersion);
        }
        if (message.canSupportCollectionAppInstall === true) {
            writer.uint32(120).bool(message.canSupportCollectionAppInstall);
        }
        if (message.topsnapProductsInShowcaseAttachment === true) {
            writer.uint32(128).bool(message.topsnapProductsInShowcaseAttachment);
        }
        if (message.canSupportCollectionShowcaseAttachment === true) {
            writer.uint32(136).bool(message.canSupportCollectionShowcaseAttachment);
        }
        if (message.canSupportLeadGenV15 === true) {
            writer.uint32(144).bool(message.canSupportLeadGenV15);
        }
        if (message.maxSupportedSkAdNetworkViewThroughVersion !== "") {
            writer
                .uint32(154)
                .string(message.maxSupportedSkAdNetworkViewThroughVersion);
        }
        if (message.canSupportDpaStoryAds === true) {
            writer.uint32(160).bool(message.canSupportDpaStoryAds);
        }
        if (message.supportedLeadGenVersion !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.supportedLeadGenVersion }, writer.uint32(170).fork()).ldelim();
        }
        if (message.canSupportDefaultBrowserDeeplinkFallback === true) {
            writer.uint32(176).bool(message.canSupportDefaultBrowserDeeplinkFallback);
        }
        writer.uint32(186).fork();
        for (const v of message.composerSupportedItemTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.supportedDpaComposerTemplateVersion !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.supportedDpaComposerTemplateVersion }, writer.uint32(194).fork()).ldelim();
        }
        if (message.supportsOrganicStore === true) {
            writer.uint32(200).bool(message.supportsOrganicStore);
        }
        if (message.multiAdPodRequestEnabled === true) {
            writer.uint32(208).bool(message.multiAdPodRequestEnabled);
        }
        if (message.offerDisclaimerEnabled === true) {
            writer.uint32(216).bool(message.offerDisclaimerEnabled);
        }
        if (message.canSupportMultiImageComposerTemplates === true) {
            writer.uint32(224).bool(message.canSupportMultiImageComposerTemplates);
        }
        if (message.canSupportSkanAdsets === true) {
            writer.uint32(232).bool(message.canSupportSkanAdsets);
        }
        if (message.isSnapchatPlusAdFreeTier === true) {
            writer.uint32(240).bool(message.isSnapchatPlusAdFreeTier);
        }
        writer.uint32(250).fork();
        for (const v of message.supportedThirdPartyLoginSources) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(258).fork();
        for (const v of message.supportedInteractiveStickers) {
            writer.int32(v);
        }
        writer.ldelim();
        if (message.isBroccoliCarouselRequest === true) {
            writer.uint32(264).bool(message.isBroccoliCarouselRequest);
        }
        if (message.canSupportDpaCollectionAsSnapAd === true) {
            writer.uint32(272).bool(message.canSupportDpaCollectionAsSnapAd);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseFeatureFlags();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.isPetraCapable = reader.bool();
                    break;
                case 2:
                    message.isDpaCapable = reader.bool();
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.protoCapableAdTypes.push(reader.int32());
                        }
                    }
                    else {
                        message.protoCapableAdTypes.push(reader.int32());
                    }
                    break;
                case 4:
                    message.canSupportCognacSkippableAds = reader.bool();
                    break;
                case 5:
                    message.canSupportExtendedPlayAds = reader.bool();
                    break;
                case 6:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.dpaCapableAdTypes.push(reader.int32());
                        }
                    }
                    else {
                        message.dpaCapableAdTypes.push(reader.int32());
                    }
                    break;
                case 7:
                    message.storyAdsInUserStoriesEnabled = reader.bool();
                    break;
                case 8:
                    message.petraFeatureFlags = exports.PetraFeatureFlags.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.canSupportShowsSkippableAds = reader.bool();
                    break;
                case 10:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.supportedAdTypes.push(reader.int32());
                        }
                    }
                    else {
                        message.supportedAdTypes.push(reader.int32());
                    }
                    break;
                case 11:
                    message.additionalFormatType = reader.int32();
                    break;
                case 12:
                    message.storyAdsInContentInterstitialEnabled = reader.bool();
                    break;
                case 13:
                    message.canSupportCollectionV2 = reader.bool();
                    break;
                case 14:
                    message.maxSupportedSkAdNetworkVersion = reader.string();
                    break;
                case 15:
                    message.canSupportCollectionAppInstall = reader.bool();
                    break;
                case 16:
                    message.topsnapProductsInShowcaseAttachment = reader.bool();
                    break;
                case 17:
                    message.canSupportCollectionShowcaseAttachment = reader.bool();
                    break;
                case 18:
                    message.canSupportLeadGenV15 = reader.bool();
                    break;
                case 19:
                    message.maxSupportedSkAdNetworkViewThroughVersion = reader.string();
                    break;
                case 20:
                    message.canSupportDpaStoryAds = reader.bool();
                    break;
                case 21:
                    message.supportedLeadGenVersion = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 22:
                    message.canSupportDefaultBrowserDeeplinkFallback = reader.bool();
                    break;
                case 23:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.composerSupportedItemTypes.push(reader.int32());
                        }
                    }
                    else {
                        message.composerSupportedItemTypes.push(reader.int32());
                    }
                    break;
                case 24:
                    message.supportedDpaComposerTemplateVersion = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 25:
                    message.supportsOrganicStore = reader.bool();
                    break;
                case 26:
                    message.multiAdPodRequestEnabled = reader.bool();
                    break;
                case 27:
                    message.offerDisclaimerEnabled = reader.bool();
                    break;
                case 28:
                    message.canSupportMultiImageComposerTemplates = reader.bool();
                    break;
                case 29:
                    message.canSupportSkanAdsets = reader.bool();
                    break;
                case 30:
                    message.isSnapchatPlusAdFreeTier = reader.bool();
                    break;
                case 31:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.supportedThirdPartyLoginSources.push(reader.int32());
                        }
                    }
                    else {
                        message.supportedThirdPartyLoginSources.push(reader.int32());
                    }
                    break;
                case 32:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.supportedInteractiveStickers.push(reader.int32());
                        }
                    }
                    else {
                        message.supportedInteractiveStickers.push(reader.int32());
                    }
                    break;
                case 33:
                    message.isBroccoliCarouselRequest = reader.bool();
                    break;
                case 34:
                    message.canSupportDpaCollectionAsSnapAd = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseFeatureFlags();
        message.isPetraCapable = object.isPetraCapable ?? false;
        message.isDpaCapable = object.isDpaCapable ?? false;
        message.protoCapableAdTypes =
            object.protoCapableAdTypes?.map((e) => e) || [];
        message.canSupportCognacSkippableAds =
            object.canSupportCognacSkippableAds ?? false;
        message.canSupportExtendedPlayAds =
            object.canSupportExtendedPlayAds ?? false;
        message.dpaCapableAdTypes = object.dpaCapableAdTypes?.map((e) => e) || [];
        message.storyAdsInUserStoriesEnabled =
            object.storyAdsInUserStoriesEnabled ?? false;
        message.petraFeatureFlags =
            object.petraFeatureFlags !== undefined &&
                object.petraFeatureFlags !== null
                ? exports.PetraFeatureFlags.fromPartial(object.petraFeatureFlags)
                : undefined;
        message.canSupportShowsSkippableAds =
            object.canSupportShowsSkippableAds ?? false;
        message.supportedAdTypes = object.supportedAdTypes?.map((e) => e) || [];
        message.additionalFormatType = object.additionalFormatType ?? 0;
        message.storyAdsInContentInterstitialEnabled =
            object.storyAdsInContentInterstitialEnabled ?? false;
        message.canSupportCollectionV2 = object.canSupportCollectionV2 ?? false;
        message.maxSupportedSkAdNetworkVersion =
            object.maxSupportedSkAdNetworkVersion ?? "";
        message.canSupportCollectionAppInstall =
            object.canSupportCollectionAppInstall ?? false;
        message.topsnapProductsInShowcaseAttachment =
            object.topsnapProductsInShowcaseAttachment ?? false;
        message.canSupportCollectionShowcaseAttachment =
            object.canSupportCollectionShowcaseAttachment ?? false;
        message.canSupportLeadGenV15 = object.canSupportLeadGenV15 ?? false;
        message.maxSupportedSkAdNetworkViewThroughVersion =
            object.maxSupportedSkAdNetworkViewThroughVersion ?? "";
        message.canSupportDpaStoryAds = object.canSupportDpaStoryAds ?? false;
        message.supportedLeadGenVersion =
            object.supportedLeadGenVersion ?? undefined;
        message.canSupportDefaultBrowserDeeplinkFallback =
            object.canSupportDefaultBrowserDeeplinkFallback ?? false;
        message.composerSupportedItemTypes =
            object.composerSupportedItemTypes?.map((e) => e) || [];
        message.supportedDpaComposerTemplateVersion =
            object.supportedDpaComposerTemplateVersion ?? undefined;
        message.supportsOrganicStore = object.supportsOrganicStore ?? false;
        message.multiAdPodRequestEnabled = object.multiAdPodRequestEnabled ?? false;
        message.offerDisclaimerEnabled = object.offerDisclaimerEnabled ?? false;
        message.canSupportMultiImageComposerTemplates =
            object.canSupportMultiImageComposerTemplates ?? false;
        message.canSupportSkanAdsets = object.canSupportSkanAdsets ?? false;
        message.isSnapchatPlusAdFreeTier = object.isSnapchatPlusAdFreeTier ?? false;
        message.supportedThirdPartyLoginSources =
            object.supportedThirdPartyLoginSources?.map((e) => e) || [];
        message.supportedInteractiveStickers =
            object.supportedInteractiveStickers?.map((e) => e) || [];
        message.isBroccoliCarouselRequest =
            object.isBroccoliCarouselRequest ?? false;
        message.canSupportDpaCollectionAsSnapAd =
            object.canSupportDpaCollectionAsSnapAd ?? false;
        return message;
    },
};
function createBasePetraFeatureFlags() {
    return {
        capableAdTypes: [],
        capableTopsnapMediaTypes: [],
        capableNativeTemplateTypes: [],
    };
}
exports.PetraFeatureFlags = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.capableAdTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(18).fork();
        for (const v of message.capableTopsnapMediaTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        writer.uint32(26).fork();
        for (const v of message.capableNativeTemplateTypes) {
            writer.int32(v);
        }
        writer.ldelim();
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBasePetraFeatureFlags();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.capableAdTypes.push(reader.int32());
                        }
                    }
                    else {
                        message.capableAdTypes.push(reader.int32());
                    }
                    break;
                case 2:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.capableTopsnapMediaTypes.push(reader.int32());
                        }
                    }
                    else {
                        message.capableTopsnapMediaTypes.push(reader.int32());
                    }
                    break;
                case 3:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.capableNativeTemplateTypes.push(reader.int32());
                        }
                    }
                    else {
                        message.capableNativeTemplateTypes.push(reader.int32());
                    }
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBasePetraFeatureFlags();
        message.capableAdTypes = object.capableAdTypes?.map((e) => e) || [];
        message.capableTopsnapMediaTypes =
            object.capableTopsnapMediaTypes?.map((e) => e) || [];
        message.capableNativeTemplateTypes =
            object.capableNativeTemplateTypes?.map((e) => e) || [];
        return message;
    },
};
function createBaseInventoryRequest() {
    return {
        inventoryType: 0,
        inventoryId: "",
        debugAdId: "",
        positionId: undefined,
        numAdsRequested: 0,
        isUnskippableAdSlot: false,
        responseDataType: 0,
        discoverChannelMetadata: undefined,
        featureFlags: undefined,
        clientInventoryRequestId: new Uint8Array(),
        publisherSlotId: new Uint8Array(),
        clientEngagementSignal: undefined,
        viewSource: 0,
        debugProductId: "0",
        shouldSkipStoryAdRequest: false,
        isPrefetchRequest: false,
        mockAdRequestParams: new Uint8Array(),
        inventorySubType: 0,
        debugProductIds: [],
        inventoryRequestDebugFlags: undefined,
        numberOfSubCreatives: 0,
        displayedPreRollAdInfo: undefined,
        clientRequestIds: [],
        shouldUseAdServletCache: false,
    };
}
exports.InventoryRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.inventoryType !== 0) {
            writer.uint32(8).int32(message.inventoryType);
        }
        if (message.inventoryId !== "") {
            writer.uint32(18).string(message.inventoryId);
        }
        if (message.debugAdId !== "") {
            writer.uint32(34).string(message.debugAdId);
        }
        if (message.positionId !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.positionId }, writer.uint32(42).fork()).ldelim();
        }
        if (message.numAdsRequested !== 0) {
            writer.uint32(48).int32(message.numAdsRequested);
        }
        if (message.isUnskippableAdSlot === true) {
            writer.uint32(56).bool(message.isUnskippableAdSlot);
        }
        if (message.responseDataType !== 0) {
            writer.uint32(64).int32(message.responseDataType);
        }
        if (message.discoverChannelMetadata !== undefined) {
            exports.DiscoverChannelMetadata.encode(message.discoverChannelMetadata, writer.uint32(74).fork()).ldelim();
        }
        if (message.featureFlags !== undefined) {
            exports.FeatureFlags.encode(message.featureFlags, writer.uint32(82).fork()).ldelim();
        }
        if (message.clientInventoryRequestId.length !== 0) {
            writer.uint32(90).bytes(message.clientInventoryRequestId);
        }
        if (message.publisherSlotId.length !== 0) {
            writer.uint32(98).bytes(message.publisherSlotId);
        }
        if (message.clientEngagementSignal !== undefined) {
            engagement_1.Signals.encode(message.clientEngagementSignal, writer.uint32(106).fork()).ldelim();
        }
        if (message.viewSource !== 0) {
            writer.uint32(112).int32(message.viewSource);
        }
        if (message.debugProductId !== "0") {
            writer.uint32(128).int64(message.debugProductId);
        }
        if (message.shouldSkipStoryAdRequest === true) {
            writer.uint32(136).bool(message.shouldSkipStoryAdRequest);
        }
        if (message.isPrefetchRequest === true) {
            writer.uint32(144).bool(message.isPrefetchRequest);
        }
        if (message.mockAdRequestParams.length !== 0) {
            writer.uint32(154).bytes(message.mockAdRequestParams);
        }
        if (message.inventorySubType !== 0) {
            writer.uint32(160).int32(message.inventorySubType);
        }
        writer.uint32(170).fork();
        for (const v of message.debugProductIds) {
            writer.int64(v);
        }
        writer.ldelim();
        if (message.inventoryRequestDebugFlags !== undefined) {
            exports.InventoryRequestDebugFlags.encode(message.inventoryRequestDebugFlags, writer.uint32(178).fork()).ldelim();
        }
        if (message.numberOfSubCreatives !== 0) {
            writer.uint32(184).int32(message.numberOfSubCreatives);
        }
        if (message.displayedPreRollAdInfo !== undefined) {
            exports.DisplayedPreRollAdInfo.encode(message.displayedPreRollAdInfo, writer.uint32(194).fork()).ldelim();
        }
        for (const v of message.clientRequestIds) {
            writer.uint32(202).bytes(v);
        }
        if (message.shouldUseAdServletCache === true) {
            writer.uint32(208).bool(message.shouldUseAdServletCache);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInventoryRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.inventoryType = reader.int32();
                    break;
                case 2:
                    message.inventoryId = reader.string();
                    break;
                case 4:
                    message.debugAdId = reader.string();
                    break;
                case 5:
                    message.positionId = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.numAdsRequested = reader.int32();
                    break;
                case 7:
                    message.isUnskippableAdSlot = reader.bool();
                    break;
                case 8:
                    message.responseDataType = reader.int32();
                    break;
                case 9:
                    message.discoverChannelMetadata = exports.DiscoverChannelMetadata.decode(reader, reader.uint32());
                    break;
                case 10:
                    message.featureFlags = exports.FeatureFlags.decode(reader, reader.uint32());
                    break;
                case 11:
                    message.clientInventoryRequestId = reader.bytes();
                    break;
                case 12:
                    message.publisherSlotId = reader.bytes();
                    break;
                case 13:
                    message.clientEngagementSignal = engagement_1.Signals.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.viewSource = reader.int32();
                    break;
                case 16:
                    message.debugProductId = longToString(reader.int64());
                    break;
                case 17:
                    message.shouldSkipStoryAdRequest = reader.bool();
                    break;
                case 18:
                    message.isPrefetchRequest = reader.bool();
                    break;
                case 19:
                    message.mockAdRequestParams = reader.bytes();
                    break;
                case 20:
                    message.inventorySubType = reader.int32();
                    break;
                case 21:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.debugProductIds.push(longToString(reader.int64()));
                        }
                    }
                    else {
                        message.debugProductIds.push(longToString(reader.int64()));
                    }
                    break;
                case 22:
                    message.inventoryRequestDebugFlags =
                        exports.InventoryRequestDebugFlags.decode(reader, reader.uint32());
                    break;
                case 23:
                    message.numberOfSubCreatives = reader.int32();
                    break;
                case 24:
                    message.displayedPreRollAdInfo = exports.DisplayedPreRollAdInfo.decode(reader, reader.uint32());
                    break;
                case 25:
                    message.clientRequestIds.push(reader.bytes());
                    break;
                case 26:
                    message.shouldUseAdServletCache = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseInventoryRequest();
        message.inventoryType = object.inventoryType ?? 0;
        message.inventoryId = object.inventoryId ?? "";
        message.debugAdId = object.debugAdId ?? "";
        message.positionId = object.positionId ?? undefined;
        message.numAdsRequested = object.numAdsRequested ?? 0;
        message.isUnskippableAdSlot = object.isUnskippableAdSlot ?? false;
        message.responseDataType = object.responseDataType ?? 0;
        message.discoverChannelMetadata =
            object.discoverChannelMetadata !== undefined &&
                object.discoverChannelMetadata !== null
                ? exports.DiscoverChannelMetadata.fromPartial(object.discoverChannelMetadata)
                : undefined;
        message.featureFlags =
            object.featureFlags !== undefined && object.featureFlags !== null
                ? exports.FeatureFlags.fromPartial(object.featureFlags)
                : undefined;
        message.clientInventoryRequestId =
            object.clientInventoryRequestId ?? new Uint8Array();
        message.publisherSlotId = object.publisherSlotId ?? new Uint8Array();
        message.clientEngagementSignal =
            object.clientEngagementSignal !== undefined &&
                object.clientEngagementSignal !== null
                ? engagement_1.Signals.fromPartial(object.clientEngagementSignal)
                : undefined;
        message.viewSource = object.viewSource ?? 0;
        message.debugProductId = object.debugProductId ?? "0";
        message.shouldSkipStoryAdRequest = object.shouldSkipStoryAdRequest ?? false;
        message.isPrefetchRequest = object.isPrefetchRequest ?? false;
        message.mockAdRequestParams =
            object.mockAdRequestParams ?? new Uint8Array();
        message.inventorySubType = object.inventorySubType ?? 0;
        message.debugProductIds = object.debugProductIds?.map((e) => e) || [];
        message.inventoryRequestDebugFlags =
            object.inventoryRequestDebugFlags !== undefined &&
                object.inventoryRequestDebugFlags !== null
                ? exports.InventoryRequestDebugFlags.fromPartial(object.inventoryRequestDebugFlags)
                : undefined;
        message.numberOfSubCreatives = object.numberOfSubCreatives ?? 0;
        message.displayedPreRollAdInfo =
            object.displayedPreRollAdInfo !== undefined &&
                object.displayedPreRollAdInfo !== null
                ? exports.DisplayedPreRollAdInfo.fromPartial(object.displayedPreRollAdInfo)
                : undefined;
        message.clientRequestIds = object.clientRequestIds?.map((e) => e) || [];
        message.shouldUseAdServletCache = object.shouldUseAdServletCache ?? false;
        return message;
    },
};
function createBaseInventoryRequestDebugFlags() {
    return {
        dpaTopSnapDynamic: false,
        creativeElementInteractionType: 0,
        collectionDefaultFallbackInteractionType: 0,
        dpaStoryAdMetadata: undefined,
        debugProductIds: [],
    };
}
exports.InventoryRequestDebugFlags = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.dpaTopSnapDynamic === true) {
            writer.uint32(8).bool(message.dpaTopSnapDynamic);
        }
        if (message.creativeElementInteractionType !== 0) {
            writer.uint32(16).int32(message.creativeElementInteractionType);
        }
        if (message.collectionDefaultFallbackInteractionType !== 0) {
            writer.uint32(24).int32(message.collectionDefaultFallbackInteractionType);
        }
        if (message.dpaStoryAdMetadata !== undefined) {
            dpa_ad_metadata_1.DpaStoryAdMetadata.encode(message.dpaStoryAdMetadata, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.debugProductIds) {
            writer.uint32(42).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInventoryRequestDebugFlags();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.dpaTopSnapDynamic = reader.bool();
                    break;
                case 2:
                    message.creativeElementInteractionType = reader.int32();
                    break;
                case 3:
                    message.collectionDefaultFallbackInteractionType =
                        reader.int32();
                    break;
                case 4:
                    message.dpaStoryAdMetadata = dpa_ad_metadata_1.DpaStoryAdMetadata.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.debugProductIds.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseInventoryRequestDebugFlags();
        message.dpaTopSnapDynamic = object.dpaTopSnapDynamic ?? false;
        message.creativeElementInteractionType =
            object.creativeElementInteractionType ?? 0;
        message.collectionDefaultFallbackInteractionType =
            object.collectionDefaultFallbackInteractionType ?? 0;
        message.dpaStoryAdMetadata =
            object.dpaStoryAdMetadata !== undefined &&
                object.dpaStoryAdMetadata !== null
                ? dpa_ad_metadata_1.DpaStoryAdMetadata.fromPartial(object.dpaStoryAdMetadata)
                : undefined;
        message.debugProductIds = object.debugProductIds?.map((e) => e) || [];
        return message;
    },
};
function createBaseDisplayedPreRollAdInfo() {
    return { adId: new Uint8Array(), requestId: new Uint8Array() };
}
exports.DisplayedPreRollAdInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.adId.length !== 0) {
            writer.uint32(10).bytes(message.adId);
        }
        if (message.requestId.length !== 0) {
            writer.uint32(18).bytes(message.requestId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDisplayedPreRollAdInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.adId = reader.bytes();
                    break;
                case 2:
                    message.requestId = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDisplayedPreRollAdInfo();
        message.adId = object.adId ?? new Uint8Array();
        message.requestId = object.requestId ?? new Uint8Array();
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=inventory_request.js.map